import { render } from "./mapBarriers.vue?vue&type=template&id=6353b506&scoped=true"
import script from "./mapBarriers.vue?vue&type=script&lang=ts"
export * from "./mapBarriers.vue?vue&type=script&lang=ts"

import "./mapBarriers.vue?vue&type=style&index=0&id=6353b506&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6353b506"

export default script